import {
  workFlowTasks,
  workFlowTasksMiscData,
} from '../constants/WorkFlowConstants';

import {
  createDatabaseTable,
  addDatabaseItem,
  getCustomDatabaseItems,
} from '@/services/axios/data.api';

import { getPreSignedUrl, uploadFile } from '@/utils/helpers.js';

import store from '../../store/store';

import fontsDatabaseSchema from '@/assets/data-schemas/fontsDatabaseSchema.json';

export const generateTaskObject = ({
  id,
  name,
  caption,
  props,
  customIcon,
}) => {
  const task = {
    id,
    name,
    caption,
    props,
    input: [],
    output: [],
    shape: { x: 0, y: 0 },
    previousTaskId: null,
  };
  if (customIcon) {
    task['customIcon'] = customIcon;
  }
  return task;
};

export const generateTaskMiskDataObject = ({
  isDroppable,
  isDeletable,
  isActive,
  icon,
  appearance,
  description,
  dropzones,
  options,
}) => {
  return {
    isDroppable,
    isDeletable,
    isActive,
    style: {
      icon,
      width: 90,
      height: 90,
      appearance,
    },
    description,
    dropzones,
    options,
  };
};

export const getValidatedTasksPosition = (taskX, taskY, taskName) => {
  const container = { width: 6000, height: 6000 };
  let width = 90,
    height = 90;

  if (workFlowTasksMiscData[taskName]) {
    width = workFlowTasksMiscData[taskName].style.width;
    height = workFlowTasksMiscData[taskName].style.width;
  }

  if (taskX > container.width) {
    taskX = Math.max(0, container.width - width);
    if (taskY + height < container.height) taskY += height;
  }

  if (taskY > container.height) {
    taskY = Math.max(0, container.height - height);
  }

  if (taskY < 0) {
    taskY = 50;
  }

  if (taskX < 0) {
    taskX = 0;
  }

  return { x: taskX, y: taskY };
};

export const getDefaultTaskName = (existingTaskNames, defaultTaskName) => {
  if (!existingTaskNames.includes(defaultTaskName)) {
    return defaultTaskName;
  }

  const numbers = existingTaskNames
    .filter((name) => name.startsWith(defaultTaskName + '_'))
    .map((name) => {
      const match = name.match(new RegExp(`${defaultTaskName}_(\\d+)$`));
      return match ? parseInt(match[1]) : 0;
    });

  const maxNumber = numbers.reduce((max, num) => Math.max(max, num), 0);

  return `${defaultTaskName}_${maxNumber + 1}`;
};

export const getWorkflowDatabaseTaskSchema = (startTask, params) => {
  const databaseScheme = workFlowTasks.find((ele) => ele.name === 'Database');
  const propItems = params.navbarElements.reduce((acc, ele) => {
    acc[ele.name] = `{${ele.name}}`;

    return acc;
  }, {});
  databaseScheme.id = startTask.id + 1;
  databaseScheme.previousTaskId = startTask.id;
  databaseScheme.props = {
    database: params.database.name,
    databaseName: 'Database_Antwort',
    item: propItems,
  };
  databaseScheme.shape.x = startTask.shape.x + 150;
  databaseScheme.shape.y = startTask.shape.y - 150;

  return databaseScheme;
};

export const getEndTaskList = () => {
  return ['Redirect', 'JsonMapper', 'End'];
};

export const FONTS_DATABASE_TYPE = 'custom-fonts';

export const getCustomFontsDatabase = () => {
  return store.getters.getDatabaseList?.find(
    (database) => database.type === FONTS_DATABASE_TYPE
  );
};
export const createFontsDatabase = async () => {
  try {
    const databaseSchema = fontsDatabaseSchema.map((schema, index) => ({
      ...schema,
      id: Date.now() + (index + 1),
    }));

    const formData = new FormData();
    formData.append('caption', 'system - custom-fonts');
    formData.append('add_only', false);
    formData.append('icon', null);
    formData.append(
      'tablename',
      `${store.getters?.getUser?.username}_system-custom-fonts`
    );

    formData.append('tabletype', FONTS_DATABASE_TYPE);
    formData.append('type', FONTS_DATABASE_TYPE);
    formData.append('database_type', 'DynamoDB');
    formData.append('schema', JSON.stringify(databaseSchema));
    formData.append(
      'layout',
      '{"tabs":[{"id":0, "rows":[{"id":0, "cols":[{"id":0}]}]}]}'
    );

    await createDatabaseTable(formData);
  } catch (error) {
    throw new Error('error while creating database table');
  }
};

export const saveCustomFonts = async (item) => {
  try {
    let custonFontsDatabase = getCustomFontsDatabase();
    if (!custonFontsDatabase) {
      await createFontsDatabase();
      await store.dispatch('fetchUserDataBase');
      custonFontsDatabase = getCustomFontsDatabase();
    }

    const preSignedUrl = await getPreSignedUrl(
      custonFontsDatabase?.name,
      item.font.name
    );
    // formBuilderItem.value.link = preSignedUrl.signature.key;
    await uploadFile(preSignedUrl, item.font);

    const payload = {
      item: {
        ...item,
        font: {
          extension: item.font.name.split('.')[1],
          size: item.font.size / 1000,
          created: item.font.lastModified,
          name: item.font.name,
          link: preSignedUrl.signature.key,
          modified: item.font.lastModified,
          readOnly: true,
          type: item.font.type,
        },
      },
    };

    return await addDatabaseItem(custonFontsDatabase?.name, payload);
  } catch (error) {
    throw new Error('error while creating database item');
  }
};

export const getCustomFonts = async () => {
  try {
    const database = getCustomFontsDatabase();

    if (database) {
      const response = await getCustomDatabaseItems(database.name, '', true);

      const data = response.data.items;
      return data;
    }
    return [];
  } catch (error) {
    return [];
  }
};
